import State from 'store/State';
import { selectComponentKeysByType } from 'layout/store/selectors';
import { WidgetType } from 'widgets/WidgetType';
import { selectWidgetInstancesState } from 'widgets/store/selectors';

export const selectOrderVolumeProfileWidgetKeys: (state: State) => string[] = (
    state
) => selectComponentKeysByType(state, WidgetType.ORDER_VOLUME_PROFILE);

export const selectOrderVolumeProfilesWidgetsState = (state: State) =>
    selectWidgetInstancesState(state)[WidgetType.ORDER_VOLUME_PROFILE];

export const selectOrderVolumeProfileState = (
    state: State,
    widgetKey: string
) => selectOrderVolumeProfilesWidgetsState(state)[widgetKey];
